const API_PATH = process.env.API || 'https://hasura-v1-0-0-rc1-nvc7jgcp7q-uc.a.run.app';

const stage = process.env.NODE_ENV || 'production';
const config = {
  api: {
    url: `${API_PATH}/api`,
    path: API_PATH,
    graphql: `${API_PATH}/v1/graphql`,
    graphqlAuth: 'https://nominas-microservices-mpnvn3hbpq-uc.a.run.app/graphql',
    graphqlWithFiles: 'https://files-microservices-mpnvn3hbpq-uc.a.run.app/graphql',
    password: 's%dzmn-cAKPTVj62NSTX@Ncj62NSTL$us%dzmndsdT',
    urlApiNotificaciones: 'https://notifications-microservices-mpnvn3hbpq-uc.a.run.app',
    rest: {
      url: 'https://nominas-microservices-mpnvn3hbpq-uc.a.run.app/',
      importAdNEmployments: 'rh/import-adn-employments',
      uploadFile: 'rh/upload-file',
      uploadFileCurp: 'rh/upload-file-curp',
      importMultipleNomina: 'rh/import-multiple-nomina',
      uploadMultipleFiles: 'rh/upload-multiple-files',
      importNomina: 'rh/import-nomina',
      importDetalleNomina: 'rh/import-detalle-nomina',
      importPrestamos: 'rh/import-prestamos',
    },
  },
  stage,
  firebaseConfig: {
    apiKey: 'AIzaSyBsqX1hRDemZcBcqkscT18E1hNLbwDhIf4',
    authDomain: 'adn-plus.firebaseapp.com',
    databaseURL: 'https://adn-plus.firebaseio.com',
    projectId: 'adn-plus',
    storageBucket: 'adn-plus.appspot.com',
    messagingSenderId: '1034636541805',
    appId: '1:1034636541805:web:70159afb978fb0738fa464',
    clientId: '1034636541805-l2k9fv92mpq84smod2lggh8lgec2rufn.apps.googleusercontent.com',
    scopes: ['email', 'profile'],
  },
};

export default config;
